import { Outlet } from "react-router-dom";

// Layout without Navbar & Footer
export default function PlainLayout() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Outlet />
    </main>
  );
}
